// extracted by mini-css-extract-plugin
module.exports = {"gorseYellowOrange":"#ff9800","footerColor":"#2f6177"};